<template>

    <div class="layout"  id="homeBox">

            <div class="lay_header" >
                <el-popover ref="pop_tree"
                            placement="bottom"
                            popper-class="pop_open"
                            trigger="hover">

                    <el-tree ref="customTree" lazy :load="loadNode"  :data="rptType"
                             :element-loading-text="$t('tips_data_loading_in_progress')"
                             :props="nodeProps"    node-key="id" highlight-current  :expand-on-click-node="true"  @node-click="handleNodeClick">
                    </el-tree>

                    <span slot="reference" class="icon-light-component-filedeal-newFolder font-button iconfontcolor" style="font-size: 24px;height:38px;"> </span>


                </el-popover>

                <el-tag   type="info" style=" float:right;position: relative;margin-top:2Px;margin-right:10px;width:210px;height:30px;font-size: 14px;overflow: hidden; text-overflow:ellipsis;white-space:nowrap;"> {{ rptInfo.name }}</el-tag>

            </div>
        <div class="lay_content">

        <el-collapse v-model="activeName" >

            <el-collapse-item :title="$t('report_parameter')" name="cs">

                        <div v-for="item in  parmObj">
                            <div class="lay_content">
                            <span class="lay_col_label">{{item.title}}</span>
                            <div v-if="item.type=='text'" >

                                    <el-input  :class="lay_col_item"
                                            :placeholder="$t('form_please_enter')"
                                            class="lay_col_item"
                                            suffix-icon="el-icon-date"
                                            v-model="item.value">
                                    </el-input>


                            </div>
                            <div v-if="item.type=='select' " >


                                    <el-select v-model="item.value"  size="small" class="lay_col_item" >
                                        <el-option
                                                v-for="item1 in parmData[item.name]"
                                                :key="item1.id"
                                                :label="item1.name"
                                                :value="item1.id"

                                        ></el-option>
                                    </el-select>


                            </div>
                            <div v-if="item.type=='date'" class="lay_col_item">

                                <el-date-picker  v-model="item.value"  :type="item.datatype" :value-format="item.format"  :format="item.format" size="small" :placeholder="$t('form_date')" style="width:160px" >
                                </el-date-picker>

                            </div>
                        </div>
                  </div>
                <div style="width:100%;margin:0 auto; text-align: center;line-height:36px;">
                    <el-button type="primary" plain icon="el-icon-search" size="mini" @click="btn('run')">{{$t('button_search_for')}}</el-button>

                </div>

            </el-collapse-item>

                <el-collapse-item :title="$t('report_authorization')" name="qx">

                    </el-collapse-item>
                    <el-collapse-item :title="$t('report_subscribe')" name="dy">

                    </el-collapse-item>
                    <el-collapse-item :title="$t('report_attribute')" name="dx">

                    </el-collapse-item>
                </el-collapse>

            </div>





    </div>














</template>
<script>
    import { mapGetters } from "vuex";
    import * as jUtil from '@/utils/spreadJs.js';

    export default {
        name: "reportList",
        data(){

            return {
                isCollapse: true,
                rptType:[],
                rptList:[],
                activeName:"cs",
                parmData:{},
                parmObj:{},
                rptInfo:{},
                nodeProps: { children:false, label: "label", isLeaf: "leaf" },

            };
        },
        watch: {

        },

        mounted() {
            this.rptType=[{id:1,type:'rpt',label:this.$t('report_statistical_report')},
                {id:2,type:'set',label:this.$t('report_data_upload')},
                {id:3,type:'input',label:this.$t('report_data_entry')}];

        },
        methods: {

            btn(id) {
                let id_family = id.split("-");
                let sid = id_family[1];
                switch (id_family[0]) {
                    case 'open':
                        this.$refs.pop_tree.showPopper = true;
                        break;
                    case 'run':
                        this.$parent.btn('run');
                        break;
                    default:
                        break;
                }
            },

            loadNode(node,resolve){
                if (node.level==0)
                {
                    resolve(this.rptType);
                    return;
                }
                else {
                    var p = {};
                    p.type = node.data.type;
                    jUtil.loadReportList(p).then((res) => {
                        resolve(res.data);
                    });
                }
            },
            shuaxin() {

                var p = {};
                p.type = 'rpt';
                jUtil.loadReportList(p).then((res) => {
                    this.$refs['customTree'].updateKeyChildren(1, res.data);
                });

            },


            handleNodeClick(e,node,item) {
                if(node.level>1) {
                   this.$emit('handleNodeClick', node.data);
                }
            },
            setParmDetail(item,data,argdata) {
                this.parmObj=item.parm?item.parm:{};
                this.rptInfo=item.info?item.info:{};
                this.parmData=data;
                if(argdata){
                $.each(this.parmObj, function (key, data) {
                    var name=data.name;
                 if(argdata.hasOwnProperty(name))   data.value=argdata[name];
                });}
                this.activeName="cs";

            },
            getArgsObj()
            {
                var _this=this;
                let args={};
                $.each(_this.parmObj, function (key, data) {
                     if(data.type=="select" && _this.parmData[data.name])
                    {
                        var op =_this.parmData[data.name].filter((item)=>{
                            return item.id=== data.value
                        })
                        args[data.name]=op.length>0?op[0].id:data.value;
                        args[data.name+"_t"]=op.length>0?op[0].name:"";
                    }
                    else if(data.type=="date" )
                    {
                        if(data.value==null|| data.value==undefined ) data.value=new Date();
                        // console.log(data.value);
                        args[data.name]=data.value;
                        if ( data.datatype='month')
                        {
                            args[data.name+"_s"]=data.value+"-01";
                            var d=data.value.split("-");
                            var lastDay= new Date(d[0],d[1],0).getDate();
                            args[data.name+"_e"]=data.value+"-"+lastDay;
                        }
                    }
                    else
                        args[data.name]=data.value;
                });
                return args;
            },



        }
    };


</script>

<style lang="scss" >


    .layout {
        padding: 0px;
        height: calc(100% - 0px);
        width: 260px;

    }
    .lay_header{
        padding: 0px;
        margin: 0px;
        height:38px;
        width: 260px;
        border: #ac2925;
    }
    .lay_content{
        padding: 0px;
        position: relative;
        float: left;
        width: 260px;
        height: calc(100% - 38px);
    }
    .lay_col_label
    {   position: relative;
        padding: 10px 0px;
        width: 80px;
        float: left;
    }
    .lay_col_item
    {   padding: 5px 0px;
        margin: 0px;
        height: 36px;
        position: relative;
        float: left;
        width: 160px;
    }
  .pop_open {

    max-height:calc(100% - 220px) !important;
    opacity: 0.95;
    overflow-x: hidden;

}
    .el-collapse-item__header{
        font-size: 8pt;
        height:36px;
        color: #babdbf ;
    }
    .el-collapse-item__header:hover{
        color: #4b36f6 ;
        background: #f2f2f2;

    }
   .el-collapse-item__header.is-active{
        font-size: 10pt;
        color: #365077 ;
        background: #f2f2f2;

    }


</style>
